export const formatAnvisaNumber = (value: string) => {
  return value
    .replace(/\D/g, '') // remove tudo que não for número
    .replace(/^(\d{5})(\d)/, '$1.$2')
    .replace(/^(\d{5})\.(\d{6})(\d)/, '$1.$2/$3')
    .replace(/^(\d{5})\.(\d{6})\/(\d{4})(\d{0,2}).*/, '$1.$2/$3-$4');
};